import { NgOptimizedImage } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { AnalyticsModule } from './analytics/analytics.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ApplicationSettingsApi } from './application-settings/api/application-settings.api';
import { BrandingApi } from './application-settings/api/branding.api';
import { ApplicationSettingsService } from './application-settings/service/application-settings.service';
import { BrandingService } from './application-settings/service/branding.service';
import { IdentificationService } from './appointment-creation/identification/service/identification.service';
import { PatientApi } from './appointment-creation/patient/api/patient.api';
import { PatientService } from './appointment-creation/patient/service/patient.service';
import { AppointmentCreationService } from './appointment-creation/service/appointment-creation.service';
import { AuthenticationInterceptor } from './authentication/interceptor/authentication.interceptor';
import { GlobalErrorHandler } from './global-error-handler';
import { HeaderModule } from './header/header.module';
import { PageNotFoundComponent } from './standalone-components/page-not-found/page-not-found.component';
import { ToastComponent } from './standalone-components/toast/toast.component';
import { VerificationApi } from './verification/api/verification.api';
import { VerificationService } from './verification/service/verification.service';
import { VerificationEventService } from './verification/service/verification-event.service';
import { VerificationEventStateHolderService } from './verification/verification-event-state-holder/verification-event-state-holder.service';

export function initSettings(appSettings: ApplicationSettingsService) {
  return () =>
    appSettings.loadInitialSettings().catch(() => {
      appSettings.setLoadFailed(true);
      return Promise.resolve();
    });
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbDropdownModule,
    HeaderModule,
    NgOptimizedImage,
    ToastComponent,
    PageNotFoundComponent,
    AnalyticsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initSettings,
      deps: [ApplicationSettingsService],
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    VerificationService,
    VerificationApi,
    PatientService,
    PatientApi,
    ApplicationSettingsApi,
    BrandingApi,
    ApplicationSettingsService,
    provideHttpClient(withInterceptorsFromDi()),
    IdentificationService,
    AppointmentCreationService,
    BrandingService,
    VerificationEventService,
    VerificationEventStateHolderService,
  ],
})
export class AppModule {}
